import { render } from "./GlobalVariablesSection.vue?vue&type=template&id=02fc8bab&scoped=true&ts=true"
import script from "./GlobalVariablesSection.vue?vue&type=script&lang=ts"
export * from "./GlobalVariablesSection.vue?vue&type=script&lang=ts"

import "./GlobalVariablesSection.vue?vue&type=style&index=0&id=02fc8bab&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02fc8bab"]])

export default __exports__